import styled from 'styled-components';

export const Container = styled.div`
  grid-area: hoursPack;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors[1300]};
  padding: 1rem;
  min-height: 20rem;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray100};

  p {
    margin-top: auto;
    margin-bottom: auto;
    text-align: center;
    padding: 0 2rem;
    font-weight: 700;
    font-size: 24px;
  }

  legend {
    color: ${({ theme }) => theme.colors.tertiary} !important;
    font-weight: 700;
    font-size: 16px;
  }
`;

export const Section = styled.div`
  background-color: ${({ theme }) => theme.colors.tertiary};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 700;
  font-size: 14px;
  padding: 10px 30px;
  border-radius: 4px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex: 1;
  margin-top: 1rem;
`;

export const Dot = styled.div<{ spentHours?: boolean; exceeded?: boolean }>`
  height: 10px;
  width: 10px;
  background-color: ${({ theme, spentHours, exceeded }) =>
    theme.colors[spentHours ? 'tertiary' : exceeded ? 2400 : 800]};
  margin-right: 0.5rem;
  border-radius: 50%;
`;
